import { render, staticRenderFns } from "./CopyRolesUsers.vue?vue&type=template&id=0a3ba2b1&scoped=true&"
import script from "./CopyRolesUsers.vue?vue&type=script&lang=js&"
export * from "./CopyRolesUsers.vue?vue&type=script&lang=js&"
import style0 from "./CopyRolesUsers.vue?vue&type=style&index=0&id=0a3ba2b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ba2b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3ba2b1')) {
      api.createRecord('0a3ba2b1', component.options)
    } else {
      api.reload('0a3ba2b1', component.options)
    }
    module.hot.accept("./CopyRolesUsers.vue?vue&type=template&id=0a3ba2b1&scoped=true&", function () {
      api.rerender('0a3ba2b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/CopyRolesUsers.vue"
export default component.exports